module.exports = __webpack_public_path__ + "img/map.0f10845e.png";